import { useIsDesktop } from "@/hooks/useResponsive";

import { RecentSales as PhoneRecentSales } from "./RecentSales.shared";
import { RecentSalesTable } from "./RecentSalesTable.web";

export { cardRecentSales, type RecentSale } from "./RecentSales.shared";

/** Recent sales: a table in the desktop shell, and the phone's list below it. */
export function RecentSales(props: Parameters<typeof PhoneRecentSales>[0]) {
  return useIsDesktop() ? <RecentSalesTable {...props} /> : <PhoneRecentSales {...props} />;
}
